import React from "react"
import {
  BdTitle2,
  BlockContentBlock,
  Button,
  SanityImg,
  SemiBdTitle5,
} from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { media } from "@sr/common"
import { rem } from "polished"
import SanityImage from "gatsby-plugin-sanity-image"
import { Link } from "gatsby"

export interface HardwareCategoryHeroPropsShape {
  hero: {
    title: string
    img: SanityImg
    _rawText: any
    buttonText: string
    buttonLink: {
      reference: {
        path: {
          current: string
        }
      }
    }
  }
}

const HardwareCategoryHero = ({ hero }: HardwareCategoryHeroPropsShape) => {
  return (
    <HardwareCategoryHeroStyled>
      <div className="hardware-category-hero__container">
        <div className="hardware-category-hero__content-container">
          <BdTitle2>{hero?.title}</BdTitle2>
          <BlockContentBlock
            className="hardware-category-hero__block-content"
            blocks={hero?._rawText}
          />
          <Link
            to={hero?.buttonLink?.reference?.path?.current}
            className="hardware-category-hero__link"
          >
            <Button btnColor="var(--color-primary)">
              <SemiBdTitle5 className="hardware-category-hero__link-text">
                {hero?.buttonText}
              </SemiBdTitle5>
            </Button>
          </Link>
        </div>
        <div className="hardware-category-hero__img-container">
          {hero?.img?.asset && (
            <SanityImage
              asset={hero?.img?.asset}
              alt={hero?.img?.alt || ""}
              className="hardware-category-hero__img"
              crop={hero?.img?.crop}
              hotspot={hero?.img?.hotspot}
            />
          )}
        </div>
      </div>
    </HardwareCategoryHeroStyled>
  )
}

export default HardwareCategoryHero

const HardwareCategoryHeroStyled = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .hardware-category-hero__container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${rem(32)} ${rem(16)} 0;
    text-align: center;

    @media ${media.midUp} {
      max-width: ${rem(616)};
      padding: ${rem(40)} 0 ${rem(64)} 0;
    }

    @media ${media.stMidUp} {
      max-width: ${rem(1160)};
      flex-direction: row-reverse;
      text-align: left;
      align-items: center;

      gap: ${rem(80)};
      padding-top: ${rem(88)};
    }

    .hardware-category-hero__content-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: ${rem(16)};

      @media ${media.stMidUp} {
        justify-content: flex-start;
        align-items: flex-start;
      }

      h2 {
        font-size: ${rem(40)};
        line-height: ${rem(48)};
        max-width: ${rem(343)};

        @media ${media.midUp} {
          font-size: ${rem(56)};
          line-height: ${rem(72)};
          max-width: ${rem(528)};
        }

        @media ${media.stMidUp} {
          max-width: ${rem(509)};
        }
      }

      p {
        margin: 0;
        max-width: ${rem(321)};

        @media ${media.midUp} {
          max-width: ${rem(478)};
        }

        @media ${media.stMidUp} {
          max-width: ${rem(425)};
        }
      }

      .hardware-category-hero__link {
        width: ${rem(191)};
        height: ${rem(40)};
        color: var(--color-white);
        background: var(--color-primary);
        border-radius: ${rem(4)};
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;

        @media ${media.midUp} {
          margin-top: ${rem(8)};
        }

        @media ${media.stMidUp} {
          width: ${rem(191)};
        }

        .hardware-category-hero__link-text {
          font-size: ${rem(16)};

          @media ${media.stMidUp} {
            font-size: ${rem(16)};
          }
        }
      }
    }

    .hardware-category-hero__img-container {
      display: flex;
      justify-content: center;
      width: ${rem(343)};
      height: ${rem(280)};
      margin-top: ${rem(32)};
      border-radius: ${rem(8)};

      @media ${media.midUp} {
        width: 100%;
        height: ${rem(312)};
        margin-top: ${rem(40)};
        overflow: hidden;
      }

      @media ${media.stMidUp} {
        max-width: ${rem(470)};
        height: ${rem(456)};
        margin-top: 0;
      }

      .hardware-category-hero__img {
        width: 100%;
        height: 100%;
        border-radius: ${rem(8)};
        object-fit: cover;
      }
    }
  }
`
